import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useInvestorList = (
  investor: any,
  pubPropertyId: string,
  acctId: string
) => {
  const axios = useAxios();
  const { t } = useTranslation();
  const urlKey = t("investor-list-api");

  const { data, refetch, isFetching } = useQuery({
    queryKey: ["investor-list", investor, !!acctId, pubPropertyId], // Include searchInvester in queryKey to refetch when it changes
    queryFn: async () => {
      const params =
        investor.length > 0
          ? {
              searchTxt: investor,
              pubPropertyId: pubPropertyId,
              ...(acctId && { acctId: acctId })
            }
          : { pubPropertyId: pubPropertyId, ...(acctId && { acctId: acctId }) }; // Only include searchTxt if investor has a value
      const res = await axios.get(urlKey, { params });
      return res?.data;
    }
  });

  return { data: data?.data, refetch, isFetching };
};
